<template>
  <div v-if="path" class="row">
    <!-- fluidSelectRow -->
    <div class="col-4">
      <label
        v-tooltip="uniToolTipTranslation(label, 'en-US')"
        class="label-unidato manifoldSelectLabel"
      >
        {{ uniTranslation(label) }}</label
      >
    </div>
    <div class="col-8">
      <el-select
        v-model="selectedManifold"
        class="manifoldSelect"
        placeholder="..."
        filterable
        :disabled="isDisabled == true"
      >
        <el-option
          v-for="item in manifoldList"
          :key="item.manifoldID"
          :label="item.description"
          :value="item.manifoldID"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import manifoldService from "../../services/backend/manifoldService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    tags: {
      type: String,
      required: true
    },
    materialId: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      path: null,
      manifoldList: [],
      selectedManifold: "",
      tagList: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    selectedManifold: function(nv /*, ov*/) {
      if (nv != null && nv != undefined) {
        var idg = parseInt(nv);
        this.$store.dispatch("changeProjectProperty", {
          path: this.path,
          value: idg
        });
      }
    },
    materialId: function(nv /*, ov*/) {
      var that = this;
      that.$nextTick(function() {
        that.manifoldList = [];
        var selectId = -1;

        var requestedId = jsonHelper.getProperty(that.projects, that.path);

        manifoldService.getManifoldsByMaterialId(nv).then(function(data) {
          /* ByMaterialId(nv) --> meglio */
          data.forEach(element => {
            if (selectId == -1) selectId = element.idCollettore;
            if (element.idCollettore == requestedId) selectId = element.idCollettore;

            that.manifoldList.push({
              description: element.descrizione,
              manifoldID: element.idCollettore
            });
          });

          that.selectedManifold = selectId;
        });
      });
    }
  },
  mounted: function() {
    if (this.parentPath != undefined && this.parentPath != null && this.parentPath != "") {
      this.path = this.parentPath + this.name;

      var that = this;
      if (that.label == "") that.label = uniTranslation("S452");

      if (this.tags.substring(0, 1) === ".") {
        this.tagList = jsonHelper.getProperty(that.projects, this.parentPath + that.tags);
      }

      that.$store.subscribe(function(mutation /*, state*/) {
        if (mutation.type === "refreshAll") {
          let myObj = jsonHelper.getProperty(that.projects, that.path);
          that.selectedManifold = myObj;
        }
      });
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.manifoldSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.manifoldSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;

  .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }

  .el-input.is-disabled .el-input__inner {
    color: #606266 !important;
  }
}
</style>
